import PropTypes from 'prop-types';
import React from 'react';

import ParsedText from '../parsed_text';

import Utils from '../../../utils';
import OPComponent from '../op_component';
import ActionSheetContext from '../action_sheet_context';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../../constants/styles';

import {
  openUrl,
  openPhone,
  openPhoneOptions,
  openEmail,
  SCRAPE_PHONE_REGEX,
} from './link_handlers';

export default class OPParsedText extends OPComponent {
  static contextType = ActionSheetContext;
  openPhone = (phoneNumber) => {
    if (this.context?.actionSheet) {
      openPhoneOptions(phoneNumber, this.context.actionSheet);
    } else {
      openPhone(phoneNumber);
    }
  };

  render() {
    const linkStyle = this.props.linkStyle || THEME.linkStyle;
    const matchers = (this.props.matchers || []).concat([
      {
        type: 'url',
        style: linkStyle,
        onPress: openUrl,
      },
      {
        pattern: SCRAPE_PHONE_REGEX,
        style: linkStyle,
        onPress: this.openPhone,
        renderText: this.props.renderText,
      },
      {
        type: 'email',
        style: linkStyle,
        onPress: openEmail,
      },
    ]);
    return (
      <ParsedText style={this.props.style} parse={matchers}>
        {this.props.children}
      </ParsedText>
    );
  }
}
